import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false,
  adsById: null,
  pageNumber: 0,
};


export default function security_log(state = initialState, action) {
  switch (action.type) {
    case types.SET_SECURITY_LOG:
      return {
        ...state,
        securityLogslist: action.payload
      };
    case types.SET_DOCUMENT_JOURNAL_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case types.SET_SECURITY_LOG_PAGE:
      return {
        ...state,
        pageNumber: action.payload
      };
    case types.SET_SECURITY_LOG_COUNT:
      return {
        ...state,
        count: action.payload
      };

    default:
      return state;
  }
}